import React, {Component} from 'react';
import {withStyles} from '@material-ui/core';
import config from "../config";
import {Helmet} from "react-helmet";
import {metaDescriptions, metaImages, metaTitles, title} from "../website-utils/meta";
import {connect} from "react-redux";
import {fetchBusinessById} from "../state/actions/business";
import ScrollToTopOnMount from "../website-utils/ScrollToTopOnMount";

import BusinessHeader from '../parts/BusinessHeader';
import Footer from '../parts/Footer';


export class ContactPage extends React.Component {
  componentDidMount() {
    window.analytics.page("Business", "Contact");

    // Check if the user is "logged in"
    const businessId = localStorage.getItem('businessId');
    if (businessId) {
      this.props.fetchBusinessById(businessId);
    }
  }

  getStartedClicked = () => {
    if (this.props.business) {
      this.props.history.push('/' + this.props.business.slug);
    } else {
      this.props.history.push(config.routes.businessSignUp);
    }
  };

  render() {
    window.prerenderReady = true;
    const {classes} = this.props;

    return (
      <div className="business home">
        <Helmet>
          {title('SingleShift - Contact')}
          {metaTitles('SingleShift - Contact')}
          {metaDescriptions('Book online in seconds and schedule a Pro for whenever you need them in the next day or week.')}
        </Helmet>
        <ScrollToTopOnMount/>

        {/* HERO */}
        <div className={`${classes.hero} hero`}>
          <div className="container">
            <BusinessHeader/>
            <div className="row justify-content-md-center">
              <div className={`${classes.headline} col-md-6 headline text-center`}>
                <p className={`${classes.pageIdentifier} text-uppercase`}>Contact</p>
                <h1>Say hello.</h1>
                <p>We’re happy to answer questions or walk you through how everything works.</p>
                <a href="https://cal.mixmax.com/hsukenooi-113/singleshift" className={`${classes.heroBtn} btn btn-primary btn-xlg btn-pointer`} target="_blank">Schedule Call</a>
              </div>
            </div>
          </div>
        </div>

        <div className={classes.section}>
          <div className="container">
            <div className="row justify-content-md-center">
              <div className="col-md-6">
                <ul className="list-unstyled text-center">
                  <li>Email: hsuken@singleshift.sg</li>
                  <li>Phone: +65 8753 8329</li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <Footer/>

      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  business: state.business.item,
});

const mapDispatchToProps = (dispatch) => ({
  fetchBusinessById: (id) => dispatch(fetchBusinessById(id)),
});

const styles = (theme) => ({
  hero: {
    backgroundColor: '#004DAA',
  },
  headline: {
    margin: '60px 0',
  },
  heroBtn: {
    marginBottom: '15px',
  },
  pageIdentifier: {
    marginBottom: '10px !important',
    fontSize: '18px !important',
    letterSpacing: '0.75px',
    fontWeight: '800',
  },
  section: {
    padding: '100px 0',
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(ContactPage));



// WEBPACK FOOTER //
// ./src/pages/ContactPage.js